import { motion } from "framer-motion";

const topics = [
  "Terminology Primer",
  "Background-to-Role Mapping",
  "Self-Assessment Framework",
  "Transferable Strengths",
  "Learning Architecture",
  "Portfolio Strategy",
  "Credential Strategy",
  "Networking System",
  "Positioning Statement",
  "CV & LinkedIn Redesign",
  "Technical & Behavioral Interviews",
  "90-Day Action Plan",
];

export const WhatsInside = () => {
  return (
    <section id="inside" className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-40">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="label-caps text-white/50 mb-6">What&apos;s inside</p>
          <h2 className="font-origin font-light text-3xl sm:text-4xl leading-tight tracking-tight">
            Everything you need to build the crossing, step by step.
          </h2>
          <p className="mt-6 text-white/60 leading-relaxed max-w-md">
            Terminology, examples, templates and trackers — a workbook you actually use,
            not another course you never finish.
          </p>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {topics.map((t, i) => (
            <motion.div
              key={t}
              data-testid={`topic-${i}`}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="bg-[#0D0B14] p-6 flex items-center gap-4 hover:bg-[#16121F] transition-colors duration-300"
            >
              <span className="font-mono2 text-xs text-[var(--neon-cyan)]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-white/80">{t}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
